module.exports = __webpack_public_path__ + "static/videoMayaCentaurus-e86a6ac1df0c83a3f97c0331750e8a36.mp4";